module.exports = __webpack_public_path__ + "img/wonde-new.8cc6de26.png";